import { useEffect } from "react";

/**
 * Lightweight per-page meta setter — updates document.title, meta description,
 * canonical link and robots directive. Restores previous values on unmount so
 * other routes stay clean.
 */
export function usePageMeta({ title, description, canonicalPath, noindex = false }) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    let metaDesc = document.querySelector('meta[name="description"]');
    const prevDesc = metaDesc?.getAttribute("content") || "";
    if (!metaDesc && description) {
      metaDesc = document.createElement("meta");
      metaDesc.setAttribute("name", "description");
      document.head.appendChild(metaDesc);
    }
    if (metaDesc && description) metaDesc.setAttribute("content", description);

    let canonical = document.querySelector('link[rel="canonical"]');
    const prevCanonical = canonical?.getAttribute("href") || "";
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    if (canonicalPath) {
      const origin = typeof window !== "undefined" ? window.location.origin : "";
      canonical.setAttribute("href", `${origin}${canonicalPath}`);
    }

    let robots = document.querySelector('meta[name="robots"]');
    const prevRobots = robots?.getAttribute("content") || "";
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", noindex ? "noindex, nofollow" : "index, follow");

    return () => {
      document.title = prevTitle;
      if (metaDesc && prevDesc) metaDesc.setAttribute("content", prevDesc);
      if (canonical && prevCanonical) canonical.setAttribute("href", prevCanonical);
      if (robots) robots.setAttribute("content", prevRobots || "index, follow");
    };
  }, [title, description, canonicalPath, noindex]);
}
